require('./RAVerticalSliderStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const Immutable = require('immutable');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const RARiskInput = require('./RARiskInput/RARiskInput');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const { PERCENTAGE_SYMBOL } = require('constants/index');

class RAVerticalSliderStep extends React.Component {
    buildFooterDisclaimer() {
        const begginingFooterDisclaimer = (
            <FormattedText
                className="ra-vertical-slider__footer-disclaimer-strong"
                value="volatilityVerticalSlider-volatilityVerticalSlider_footerDisclaimer1Begin"
            />
        );

        return (
            <FormattedTextWithComponents
                className="ra-vertical-slider__footer-disclaimer-grey"
                value="volatilityVerticalSlider-footerDisclaimer1"
                injectedComponents={[begginingFooterDisclaimer]}
            />
        );
    }

    render() {
        const {
            sliderValue,
            disabled,
            title,
            subtitle,
            titleSlider,
            titleTooltip,
        } = this.props;
        const footerDisclaimer = this.buildFooterDisclaimer();
        const maxLabel = formatText(
            'volatilityVerticalSlider-volatilityVerticalSlider_maxValue',
        );
        const immMarksValues = Immutable.fromJS({
            0: `0 ${PERCENTAGE_SYMBOL}`,
            5: `5 ${PERCENTAGE_SYMBOL}`,
            10: `10 ${PERCENTAGE_SYMBOL}`,
            15: `15 ${PERCENTAGE_SYMBOL}`,
            20: `20 ${PERCENTAGE_SYMBOL}`,
            25: `25 ${PERCENTAGE_SYMBOL}`,
            30: maxLabel,
        });

        return (
            <section className="ra-vertical-slider">
                <div className="ra-vertical-slider__header">
                    <span className="ra-vertical-slider__title">
                        {title} {titleTooltip}
                    </span>
                    <span className="ra-vertical-slider__subtitle">
                        {subtitle}
                    </span>
                </div>
                <div className="ra-vertical-slider__title-slider">
                    {titleSlider}
                </div>
                <div className="ra-vertical-slider__container">
                    <div className="ra-vertical-slider__container__slider">
                        <OKSliderInput
                            defaultValue={sliderValue}
                            disabled={disabled}
                            hasInput={false}
                            marks={immMarksValues}
                            min={0}
                            max={30}
                            onChange={this.props.changeSliderValue} // eslint-disable-line
                            valueLabelType="reference"
                        />
                    </div>
                    <div className="ra-vertical-slider__container-input">
                        <RARiskInput
                            amount={this.props.amount}
                            updateVolatilityInputValue={
                                this.props.updateVolatilityInputValue
                            }
                            showBlurZero={true}
                            sliderValue={sliderValue}
                            disabled={disabled}
                        />
                    </div>
                    <div className="ra-vertical-slider__footer">
                        {footerDisclaimer}
                    </div>
                </div>
            </section>
        );
    }
}

RAVerticalSliderStep.propTypes = {
    sliderValue: PropTypes.number,
    changeSliderValue: PropTypes.func,
    updateVolatilityInputValue: PropTypes.func,
    amount: PropTypes.number,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    titleSlider: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subtitle: PropTypes.string,
    titleTooltip: PropTypes.any,
};

module.exports = RAVerticalSliderStep;
